"use client";
import CTALink from "@/components/CTA/variants/CtaLink";

interface CtaProps {
  title: string;
  buttonLabel: string;
  buttonUrl?: string;
}

export default function Cta({ title, buttonLabel, buttonUrl = "#" }: CtaProps) {
  return (
    <section id="cta" className="text-center">
      <h2 className="text-2xl font-semibold mb-6 text-balance">{title}</h2>
      <CTALink label={buttonLabel} url={buttonUrl} type="brand" size="lg" />
    </section>
  );
}
